import { cn } from "@/utils";
import * as Dialog from "@radix-ui/react-dialog";
import React from "react";
import { MdClose } from "react-icons/md";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children?: React.ReactNode;
  contentClassName?: string;
  headerClassName?: string;
  childrenClassName?: string;
  renderHeader?: () => React.ReactNode;
}

const LightBox: React.FC<Props> = ({
  open,
  onOpenChange,
  children,
  renderHeader,
  headerClassName,
  contentClassName,
  childrenClassName,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Content
          title=""
          className={cn(
            "fixed inset-0 bg-black z-50 outline-none h-[100vh] flex flex-col",
            contentClassName
          )}
        >
          {/* Header with close button */}
          <div className={cn("flex justify-end", headerClassName)}>
            {renderHeader?.()}
            <button
              type="button"
              className="p-2 hover:bg-grey-200/20 transition-colors duration-100 rounded-full outline-none m-2"
              onClick={() => onOpenChange(false)}
              title="近い"
            >
              <MdClose className="text-white size-6" />
            </button>
          </div>
          <div
            className={cn(
              "flex-1 flex flex-col gap-2 items-center justify-center overflow-auto",
              childrenClassName
            )}
          >
            {children}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { LightBox };
